import { render } from "./DisplayListElement.vue?vue&type=template&id=2a39f3c4&scoped=true"
import script from "./DisplayListElement.vue?vue&type=script&lang=js"
export * from "./DisplayListElement.vue?vue&type=script&lang=js"

import "./DisplayListElement.vue?vue&type=style&index=0&id=2a39f3c4&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a39f3c4"]])

export default __exports__